<template>
    <v-breadcrumbs :items="items">
        <template #item="{ item }">
            <v-breadcrumbs-item :to="item.to">
                {{ item.title }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
</template>

<script setup lang="ts">
import type { BreadcrumbItem } from '@shared/types/BreadcrumbItem';

defineProps({
    items: {
        type: Array as PropType<BreadcrumbItem[]>,
        required: true,
    },
});
</script>
